import React from 'react';
import SEOHead from '../components/SEOHead';  
import OptimizedImage from '../components/OptimizedImage'; 
import { Users, Target, Award, Heart, CheckCircle, Star } from 'lucide-react';
 
const About = () => {
 const stats = [
    { number: '000+', label: 'Students Helped' },
    { number: '000+', label: 'College Reviews' },
    { number: '000+', label: 'Student Mentors' },
    { number: '95%', label: 'Success Rate' } 
  ]; 
 
  const values = [ 
    {
      icon: Target,
      title: 'Student-Centric',
      description: 'Every decision we make is focused on helping students succeed in their educational journey.'
    },
    {
      icon: CheckCircle,
      title: 'Verified Information',
      description: 'We ensure all college information and reviews are authentic and regularly updated.'
    },
    {
      icon: Heart,
      title: 'Empathy & Support',
      description: 'We understand the stress of college selection and provide compassionate guidance.'
    },
    {
      icon: Award,
      title: 'Excellence',
      description: 'We strive for excellence in everything we do, from our platform to our support services.'
    }
  ];

  return (
    <div style={{ paddingTop: '80px' }}>
      <SEOHead 
        title="About Grad Vikalp - Your Trusted College Guidance Partner"
        description="Learn about Grad Vikalp's mission to democratize college selection through verified information, personalized guidance, and real student connections. Discover our story, values, and commitment to student success."
        keywords="about grad vikalp, college guidance platform, education counseling, student success, college selection help, verified college reviews"
        url="/about" 
        type="website"
        pageKey="about"
      />

      {/* Hero Section */}
      <section style={{ marginBottom: '-20px' }}>
        <div className="container text-center">
          <h1 className="display-4 fw-bold text-dark mb-2">About Grad Vikalp</h1>
          <br></br>
          <p className="lead text-muted mx-auto" style={{ maxWidth: '800px' }}>We're on a mission to democratize college selection by providing students with verified information, personalized guidance, and real connections to make informed decisions.</p>
        </div>
      </section>

      {/* Stats Section */}
      {/* <section className="py-5 bg-white">
        <div className="container">
          <div className="row g-4 text-center">
            {stats.map((stat, index) => (
              <div key={index} className="col-6 col-md-3">
                <div className="stats-number text-primary">{stat.number}</div>
                <div className="text-muted">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Our Story Section */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6">
              <h2 className="h1 fw-bold text-dark mb-4">Our Story</h2>
              <div className="text-muted">
                <p className="mb-4">
                  Choosing the right college is one of the biggest decisions in a student’s life — yet the process is
                  often confusing, stressful, and filled with uncertainty. Every year, lakhs of students and parents
                  struggle to understand ranks, cutoffs, quotas, and counseling procedures. We’ve been there too, and
                  we knew something had to change.
                </p>
                <p className="mb-4">
                  That’s why we built GradVikalp — a platform that simplifies college selection through personalized
                  college lists. Instead of one-size-fits-all advice, we use real data, rank-based predictions, and
                  simple tools to help students discover the best options based on their own scores, preferences, and
                  goals. No more guesswork, no more last-minute panic.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
               <OptimizedImage
  src="/Grad-Vikalp.png"
  alt="Grad Vikalp logo"
  title="Students celebrating college admission success with Grad Vikalp guidance"
  className="w-100 h-auto object-contain rounded-4 shadow-lg"
  loading="lazy"
/>
            </div>
          </div>
        </div>
      </section>

      {/* Our Values Section */}
      <section className="py-5 bg-white">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="h1 fw-bold text-dark mb-3">Our Values</h2>
            <p className="lead text-muted">The principles that guide everything we do</p>
          </div>

          <div className="row g-4 text-center">
            {values.map((value, index) => {
              const Icon = value.icon;
              return (
                <div key={index} className="col-lg-3 col-md-6">
                  <div className="feature-icon bg-primary bg-opacity-10 mb-3">
                    <Icon className="text-primary" size={32} />
                  </div>
                  <h3 className="h5 fw-bold text-dark mb-3">{value.title}</h3>
                  <p className="text-muted">{value.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Mission Statement */}
      <section className="py-5 bg-blue-gradient">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center text-white">
              <h2 className="h1 fw-bold mb-4">Our Mission</h2>
              <p className="lead text-blue-100">
                To empower every student with the information, tools, and connections they need to make confident,
                informed decisions about their higher education journey. We believe that the right college choice can
                transform lives, and we're here to make that choice clearer and more accessible for everyone.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
